import React from 'react';

const LabelTooltip = ({ text }) => {
  return (
    <i className="d-flex flex-shrink-0 svg-i grey-info total-tooltip-info ml-4px cursor-pointer position-relative">
      <div className="total-tooltip pointer-events-none bg-light-blue border-radius-md d-flex align-items-start min-width-210px position-absolute absolute-x-center px-20px py-16px top-24px z-index-999991">
        <span className="font-size-12 font-base text-dark-gray text-left">{text}</span>
      </div>
    </i>
  );
};

export default LabelTooltip;